import React from "react";
import {
    Paper,
    Typography,
} from "@material-ui/core";
import useStyles from "../styles";
import classnames from "classnames";

export default function MostSold({ title, productName }) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.widgetWrapper}>
                <Paper className={classes.paper} classes={{
                    root: classnames(classes.widgetRootShadowBlack)
                }}>
                    <div className={classnames(classes.widgetHeader)}>
                        <Typography variant="h5" noWrap className={classes.title}>
                            {title}
                        </Typography>
                    </div>
                    <div className={classnames(classes.fullHeightBody)}>
                        <div className={classes.divCenterCounter}>
                            <p style={{fontSize: "40px"}}>{productName}</p>
                        </div>
                    </div>
                </Paper>
            </div>
        </>
    );
}
